<script>
import HorizontalScroll from "../../../../components/core/horizontal-scroll.vue";
import { TicketsIndex } from "../../controllers/tickets.index";

export default {
    name: "Tickets",
    components: { HorizontalScroll },
    mixins: [TicketsIndex],
    metaInfo: {
        title: "Tickets",
    },
    data() {
        return {
            shareMenuVisible: null,
            showToast: false, // State for showing the toast
            toastMessage: "", // Message for the toast
        };
    },
    computed: {
        sortedEvents() {
            return (events) => {
                return events
                    .sort((a, b) => {
                        if (a.event_type !== 'FREE' && b.event_type === 'FREE') return -1;
                        if (a.event_type === 'FREE' && b.event_type !== 'FREE') return 1;
                        return new Date(a.event_at) - new Date(b.event_at);
                    });
            };
        },

        todayEvents() {
            const now = new Date();
            const todayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));
            const tomorrowUTC = new Date(todayUTC);
            tomorrowUTC.setUTCDate(todayUTC.getUTCDate() + 1);

            let events = this.events.filter(event => {
                const eventDateUTC = new Date(event.event_at);
                return eventDateUTC >= todayUTC && eventDateUTC < tomorrowUTC;
            });

            return this.sortedEvents(events);
        },

        weekendEvents() {
            const now = new Date();
            const todayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
            const thisSaturdayUTC = new Date(todayUTC);
            thisSaturdayUTC.setUTCDate(todayUTC.getUTCDate() + (6 - todayUTC.getUTCDay()));
            thisSaturdayUTC.setUTCHours(0, 0, 0, 0);

            const thisSundayUTC = new Date(thisSaturdayUTC);
            thisSundayUTC.setUTCDate(thisSaturdayUTC.getUTCDate() + 1);
            thisSundayUTC.setUTCHours(23, 59, 59, 999);

            let events = this.events.filter(event => {
                const eventDateUTC = new Date(event.event_at);
                return eventDateUTC >= thisSaturdayUTC && eventDateUTC <= thisSundayUTC;
            });

            return this.sortedEvents(events);
        },

        upcomingEvents() {
            const nowUTC = new Date();
            let events = this.events.filter(event => new Date(event.event_at) > nowUTC);
            return this.sortedEvents(events);
        },

        pastEvents() {
            const now = new Date();
            const todayUTCStart = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));

            let events = this.events.filter(event => {
                const eventDateUTC = new Date(event.event_at);
                return eventDateUTC < todayUTCStart;
            });

            // Sort past events in descending order (latest first)
            return events.sort((a, b) => new Date(b.event_at) - new Date(a.event_at));
        }
    },


    methods: {
        isRsvpEvent(event) {
            if (!event || event.event_type === "FREE") {
                return false;
            }

            return (event.types || []).some((type) => Number(type.usd_price) <= 0);
        },
        toggleShareMenu(index) {
            this.shareMenuVisible = this.shareMenuVisible === index ? null : index;
        },
        copyLink(link) {
            navigator.clipboard.writeText(link)
                .then(() => {
                    this.showToastMessage("Link copied to clipboard!");
                    this.shareMenuVisible = null; // Close menu after copying
                })
                .catch((err) => {
                    console.error("Failed to copy link: ", err);
                });
        },
        openEventLink(eventId) {
            this.$router.push(`/tickets/buy/${eventId}`);
            this.shareMenuVisible = null; // Close menu after redirecting
        },
        showToastMessage(message) {
            this.toastMessage = message;
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 2000); // Hide toast after 2 seconds
        },
        isPastEvent(event) {
            const eventDate = new Date(event.event_at); // Ensure the event date is properly formatted
            return eventDate < new Date();
        },
        defaultShareLink(event) {
            const slugifiedName = event.name.toLowerCase().replace(/ /g, '-');
            return `https://magetsi.co.zw/tickets/buy/${event.event_id}/${slugifiedName}`;
        },

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },
};
</script>



<template>
    <div>
        <section class="bg-light-1 py-4 bg-white">
            <div class="container">
                <div class="d-flex justify-content-between align-items-center">
                    <h2 class="title-blog text-7">Events</h2>
                   <router-link to="/tickets/landing" class="btn btn-primary btn-sm shadow-none">
                        Add Your Event
                    </router-link>
                </div>
                <hr class="my-4">
                <div v-if="tickets.loading"
                     class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
                    <div class="loader"></div>
                </div>

                <!-- Today's Events -->
                <div v-if="todayEvents.length">
                    <h3 class="text-5 mb-4">Happening Today</h3>
                    <div class="row">
                        <template>
                            <div
                                class="col-lg-3 col-md-4 col-6 p-3"
                                v-for="(event, index) in todayEvents"
                                :key="'event-today-' + index"
                            >
                                <div class="blog-post card shadow-sm border-0 mb-3 position-relative">
                                    <router-link
                                        :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                        class="image-container"
                                    >
                                        <img class="card-img-top" :src="event.image" :alt="event.name" />
                                        <div class="gradient-overlay"></div>
                                    </router-link>
                                    <div class="card-body px-4">
                                        <div class="d-flex flex-column align-items-center text-center">

                                            <strong
                                                class="title-blog text-2 mb-2 text-truncate d-block"
                                            >
                                                {{ truncateText(event.name, 18) }}
                                            </strong>
                                            <strong
                                                class="title-blog text-1 text-truncate d-block"
                                            >
                                                {{ truncateText(event.venue, 20) }}
                                            </strong>
                                            <small
                                                class="title-blog text-1 mb-2 text-truncate d-block"
                                            >
                                                {{ event.event_at }} &bull; {{ event.time }}
                                            </small>
                                            <router-link
                                                :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                                class="btn btn-block shadow-none px-4 py-1"
                                                :class="event.event_type === 'FREE' ? 'btn-outline-success btn-sm' : 'btn-outline-primary btn-sm'"
                                            >
                                                {{ event.event_type === 'FREE' ? 'Free Event' : (isRsvpEvent(event) ? 'RSVP' : 'Buy Ticket') }}
                                            </router-link>

                                            <!-- Share Options -->
                                            <div class="share-icons d-flex align-items-center mt-2">
                                                <span class="me-2 text-muted flex-shrink-0" style="font-size: 0.85em;">Share to:</span>
                                                <a href="javascript:void(0);" @click="copyLink(defaultShareLink(event))" class="share-option ms-1">
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"/>
                                                    </svg>
                                                </a>

                                                <a :href="`https://api.whatsapp.com/send?text=Click this link to buy ${event.name} ticket: ${defaultShareLink(event)}`" target="_blank" class="share-option ms-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
                                                        <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"></path>
                                                    </svg>
                                                </a>

                                                <a :href="`sms:?&body=Check out ${event.name}! Get your ticket here: ${defaultShareLink(event)}`">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                        <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10z"/>
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <!-- Weekend Events -->
                <div v-if="weekendEvents.length">
                    <h3 class="text-5 mb-4">This Weekend</h3>
                    <div class="row">
                        <template>
                            <div
                                class="col-lg-3 col-md-4 col-6 p-3"
                                v-for="(event, index) in weekendEvents"
                                :key="'event-weekend-' + index"
                            >
                                <div class="blog-post card shadow-sm border-0 mb-3 position-relative">
                                    <router-link
                                        :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                        class="image-container"
                                    >
                                        <img class="card-img-top" :src="event.image" :alt="event.name" />
                                        <div class="gradient-overlay"></div>
                                    </router-link>
                                    <div class="card-body px-4">
                                        <div class="d-flex flex-column align-items-center text-center">
                                            <strong
                                                class="title-blog text-2 mb-2 text-truncate d-block"
                                            >
                                                {{ truncateText(event.name, 18) }}
                                            </strong>
                                            <strong
                                                class="title-blog text-1 text-truncate d-block"
                                            >
                                                {{ truncateText(event.venue, 20) }}
                                            </strong>
                                            <small
                                                class="title-blog text-1 mb-2 text-truncate d-block"
                                            >
                                                {{ event.event_at }} &bull; {{ event.time }}
                                            </small>
                                            <router-link
                                                :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                                class="btn btn-block shadow-none px-4 py-1"
                                                :class="event.event_type === 'FREE' ? 'btn-outline-success btn-sm' : 'btn-outline-primary btn-sm'"
                                            >
                                                {{ event.event_type === 'FREE' ? 'Free Event' : (isRsvpEvent(event) ? 'RSVP' : 'Buy Ticket') }}
                                            </router-link>


                                            <!-- Share Options -->
                                            <div class="share-icons d-flex align-items-center mt-2">
                                                <span class="me-2 text-muted flex-shrink-0" style="font-size: 0.85em;">Share to:</span>
                                                <a href="javascript:void(0);" @click="copyLink(defaultShareLink(event))" class="share-option ms-1">
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"/>
                                                    </svg>
                                                </a>

                                                <a :href="`https://api.whatsapp.com/send?text=Click this link to buy ${event.name} ticket: ${defaultShareLink(event)}`" target="_blank" class="share-option ms-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
                                                        <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"></path>
                                                    </svg>
                                                </a>

                                                <a :href="`sms:?&body=Check out ${event.name}! Get your ticket here: ${defaultShareLink(event)}`">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                        <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10z"/>
                                                    </svg>
                                                </a>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <!-- Upcoming Events -->
                <div v-if="upcomingEvents.length">
                    <h3 class="text-5 mb-4">Upcoming Events</h3>
                    <div class="row">
                        <div
                            class="col-lg-3 col-md-4 col-6 p-3"
                            v-for="(event, index) in upcomingEvents"
                            :key="'event-upcoming-' + index"
                        >
                            <div class="blog-post card shadow-sm border-0 mb-3 position-relative">
                                <router-link
                                    :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                    class="image-container"
                                >
                                    <img class="card-img-top" :src="event.image" :alt="event.name" />
                                    <div class="gradient-overlay"></div>
                                </router-link>
                                <div class="card-body px-4">
                                    <div class="d-flex flex-column align-items-center text-center">
                                        <!-- Share Options -->

                                        <strong class="title-blog text-2 mb-2 text-truncate d-block">
                                            {{ truncateText(event.name, 18) }}
                                        </strong>
                                        <strong class="title-blog text-1 text-truncate d-block">
                                            {{ truncateText(event.venue, 20) }}
                                        </strong>
                                        <small class="title-blog text-1 mb-2 text-truncate d-block">
                                            {{ event.event_at }} &bull; {{ event.time }}
                                        </small>
                                        <router-link
                                            :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                            class="btn btn-block shadow-none px-4 py-1"
                                            :class="event.event_type === 'FREE' ? 'btn-outline-success btn-sm' : 'btn-outline-primary btn-sm'"
                                        >
                                            {{ event.event_type === 'FREE' ? 'Free Event' : (isRsvpEvent(event) ? 'RSVP' : 'Buy Ticket') }}
                                        </router-link>


                                            <!-- Share Options -->
                                            <div class="share-icons d-flex align-items-center mt-2">
                                                <span class="me-2 text-muted flex-shrink-0" style="font-size: 0.85em;">Share to:</span>
                                                <a href="javascript:void(0);" @click="copyLink(defaultShareLink(event))" class="share-option ms-1">
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"/>
                                                    </svg>
                                                </a>

                                                <a :href="`https://api.whatsapp.com/send?text=Click this link to buy ${event.name} ticket: ${defaultShareLink(event)}`" target="_blank" class="share-option ms-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50">
                                                        <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"></path>
                                                    </svg>
                                                </a>

                                                <a :href="`sms:?&body=Check out ${event.name}! Get your ticket here: ${defaultShareLink(event)}`">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                        <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10z"/>
                                                    </svg>
                                                </a>

                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               <!--Past Events-->
                <div v-if="pastEvents.length">
                    <h3 class="text-5 mb-4">Past Events</h3>
                    <div class="row">
                        <div
                            class="col-lg-3 col-md-4 col-6 p-3"
                            v-for="(event, index) in pastEvents"
                            :key="'event-past-' + index"
                        >
                            <div class="blog-post card shadow-sm border-0 mb-3 position-relative">
                                <div class="image-container">
                                    <img class="card-img-top" :src="event.image" :alt="event.name" />
                                    <div class="gradient-overlay"></div>
                                </div>
                                <div class="card-body px-4">
                                    <div class="d-flex flex-column align-items-center text-center">
                                        <strong class="title-blog text-2 mb-2 text-truncate d-block">
                                            {{ truncateText(event.name, 18) }}
                                        </strong>
                                        <strong class="title-blog text-1 text-truncate d-block">
                                            {{ truncateText(event.venue, 20) }}
                                        </strong>
                                        <small class="title-blog text-1 mb-2 text-truncate d-block">
                                            {{ event.event_at }} &bull; {{ event.time }}
                                        </small>
                                        <!-- Conditionally render "Buy Ticket" and share options -->
                                        <div v-if="!isPastEvent(event)">
                                            <router-link
                                                :to="`/tickets/buy/${event.event_id}/${event.name.toLowerCase().replace(/ /g, '-')}`"
                                                class="btn btn-block btn-outline-primary btn-sm shadow-none px-4 py-1"
                                            >
                                                {{ isRsvpEvent(event) ? 'RSVP' : 'Buy Ticket' }}
                                            </router-link>
                                            <!-- Share Options -->
                                            <div class="share-icons d-flex align-items-center mt-2">
                                                <span class="me-2 text-muted flex-shrink-0" style="font-size: 0.85em;">Share to:</span>
                                                <a
                                                    href="javascript:void(0);"
                                                    @click="copyLink(defaultShareLink(event))"
                                                    class="share-option ms-1"
                                                >
                                                    <svg
                                                        class="w-6 h-6 text-gray-800 dark:text-white"
                                                        aria-hidden="true"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            stroke="currentColor"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                                          />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                <!-- Toast Notification -->
                <div v-if="showToast" class="toast-notification">
                    {{ toastMessage }}
                </div>

                <!-- Pagination
                <ul v-if="tickets.content.last_page > 1" class="pagination justify-content-center my-5">
                    <li class="page-item" v-if="tickets.content.current_page > 1">
                        <a class="page-link" href="#" @click.prevent="tickets.fetchPrevious()" tabindex="-1">
                            <i class="fas fa-angle-left"></i>
                        </a>
                    </li>
                    <template v-for="page in tickets.content.last_page">
                        <li class="page-item" :key="'page-' + page"
                            v-if="page > tickets.content.current_page - 3 && page < tickets.content.current_page + 3"
                            :class="{ active: page === tickets.content.current_page }"
                        >
                            <a class="page-link" href="#" @click.prevent="tickets.fetchPage(page)">{{ page }}</a>
                        </li>
                    </template>
                    <li v-if="tickets.content.last_page > 6" class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">...</li>
                    <li class="page-item" v-if="tickets.content.current_page < tickets.content.last_page">
                        <a class="page-link" href="#" @click.prevent="tickets.fetchNext()">
                            <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
        </section> -->

        <!-- New Section -->
        <section class="bg-light py-5">
            <!-- Header Section -->
            <div class="container text-center">
                <h1 class="text-9 font-weight-bold mb-5">The Convenience of Online Ticketing</h1>
            </div>

            <!-- Western Culture Description -->
            <div class="container my-5">
                <p class="text-3">
                    In Western culture, online ticketing has become the standard for purchasing tickets to a wide array of events, from concerts and sports games to theater performances and festivals. This convenience-oriented approach enables people to quickly buy tickets from any location and even choose preferred seating, all through a few clicks on their smartphones or computers. Online ticketing platforms offer instant digital tickets that eliminate the need for physical copies, streamlining the process and enhancing security. For event organizers, online ticketing also provides valuable real-time data on ticket sales and attendee demographics, making it easier to plan, market, and optimize events. As a result, online ticketing in the West has become integral to the cultural experience, allowing people to secure access to events quickly and efficiently while reducing costs and environmental impact through digital technology. In an increasingly digital world, convenience is everything. At <a href="https://magetsi.co.zw">Magetsi</a>, we’re revolutionizing how Zimbabweans access events, making ticket purchasing easier, faster, and more secure. Here’s everything you need to know about how <a href="https://magetsi.co.zw">Magetsi</a>'s online ticketing system works and why it’s the best choice for your next event.

                </p>

                </div>
        </section>

            <!-- Organizer Benefits Section -->
            <section class="section py-5 bg-light-4">
                <div class="container">
                    <h2 class="text-center text-9 font-weight-bold mb-4 py-5">The Benefits of Online Ticketing for the Event Organizer</h2>
                    <div class="row mb-4">
                        <div class="col-md-4">
                            <div class="benefit-box text-left larger-font">
                                <strong>Wide Reach:</strong>
                                <p>Our digital platform increases your event's visibility, attracting both local and international audiences. </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="benefit-box text-left larger-font">
                                <strong>Instant Data Access:</strong>
                                <p>Keep track of ticket sales in real time, allowing for better inventory management. </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="benefit-box text-left larger-font">
                                <strong>Low-Cost Solution:</strong>
                                <p>Compared to traditional ticketing, online ticketing reduces costs related to printing and distribution. </p>
                            </div>
                        </div>
                    </div>


                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <div class="benefit-box text-left larger-font">
                                <strong>Enhanced Security:</strong>
                                <p>Every ticket purchase is documented, reducing the risk of counterfeit tickets at the event.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="benefit-box text-left larger-font">
                                <strong>Contribution A Clean Environment:</strong>
                                <p>Paperless tickets will significantly reduce environmental pollution. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        <!-- How Magetsi's Online Ticketing Works Section -->
        <section class="section py-5 bg-white">
            <div class="container">
                <div class="row">
                    <!-- Title -->
                    <div class="col-lg-5 text-lg-right text-center">
                        <h2 class="text-9 font-weight-bold">How Magetsi's Online Ticketing Works</h2>
                    </div>
                    <!-- Content -->
                    <div class="col-lg-7">
                        <p class="text-3">
                            Magetsi’s online ticketing process is designed to be straightforward. Here’s a step-by-step look:
                        </p>
                        <ul class="list-unstyled">
                            <li class="mb-3"><strong>Visit the Magetsi Website:</strong> Head to our website, where you’ll find a list of events available for ticket purchase.</li>
                            <li class="mb-3"><strong>Select Your Event:</strong> Browse through upcoming events or search for a specific event.</li>
                            <li class="mb-3"><strong>Choose Your Ticket Type:</strong> Depending on the event, you may choose between various ticket categories, such as general admission or VIP.</li>
                            <li class="mb-3"><strong>Secure Checkout:</strong> Our secure payment gateway allows you to complete your purchase quickly.</li>
                            <li class="mb-3"><strong>Get Your QR Code:</strong> After completing your purchase, you’ll receive an email with a QR code. Show this code at the event for hassle-free entry.</li>
                        </ul>
                        <p class="text-3"><strong>Pro Tip:</strong> Save your QR code in your email or phone to avoid last-minute ticket mishaps.</p>

                        <!-- See Upcoming Events Button -->
                        <div class="mt-4">
                            <button @click="scrollToTop" class="btn btn-primary btn-lg text-white">See Upcoming Events</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>



        <section class="section py-5">
            <div class="container">
                <div class="text-center mb-5">
                    <h2 class="text-9 font-weight-bold">Why Magetsi’s Online Ticketing Stands Out in Zimbabwe</h2>
                    <p class="text-3">While ticketing options are available in Zimbabwe, Magetsi provides a platform that prioritizes customer convenience and reliability. Here’s why Magetsi stands out:</p>
                </div>

                <div class="row">
                    <!-- Left Column with Icons and Content -->
                    <div class="col-lg-6">
                        <div class="d-flex mb-4">
                            <div class="icon text-success mr-3">
                                <i class="fas fa-user-check fa-2x"></i>
                            </div>
                            <div>
                                <h4 class="font-weight-bold">Focus on User Experience</h4>
                                <p>Our website is easy to navigate, offering customers a seamless purchasing journey.</p>
                            </div>
                        </div>

                        <div class="d-flex mb-4">
                            <div class="icon text-primary mr-3">
                                <i class="fas fa-headset fa-2x"></i>
                            </div>
                            <div>
                                <h4 class="font-weight-bold">Reliable Customer Support</h4>
                                <p>For any issues, our customer support team is always available to assist.</p>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-6">
                        <div class="d-flex mb-4">
                            <div class="icon text-warning y mr-3">
                                <i class="fas fa-map-marker-alt fa-2x"></i>
                            </div>
                            <div>
                                <h4 class="font-weight-bold">Local Expertise</h4>
                                <p>With years of experience in the Zimbabwean market, we understand the unique needs of local consumers and event organizers.</p>
                            </div>
                        </div>

                        <!--Did You Know -->
                        <div class="p-4 bg-white rounded shadow-sm mt-4 ml-lg-5">
                            <h5 class="font-weight-bold text-primary">Did you know?</h5>
                            <p>Magetsi recently supported ticketing for the Glowfest Festival, helping hundreds of attendees enjoy a seamless experience!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section class="section py-5 bg-light">
            <div class="container">
                <!-- Main Heading and Introduction -->
                <div class="text-center mb-5">
                    <h2 class="text-9 font-weight-bold">Planning For Your Next Event? Online Ticketing Is Your Best Choice.</h2>
                    <p class="text-3">With Magetsi, you can enjoy a wide range of advantages when purchasing tickets online, including:</p>
                </div>

                <!-- Advantages Grid with Icons -->
                <div class="row text-center">
                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="icon-box p-3 rounded bg-white shadow-sm">
                            <div class="icon text-success mb-2">
                                <i class="fas fa-globe fa-2x"></i>
                            </div>
                            <h5 class="font-weight-bold">Ease of Access</h5>
                            <p class="text-muted">Purchase tickets anytime, from anywhere</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="icon-box p-3 rounded bg-white shadow-sm">
                            <div class="icon text-primary mb-2">
                                <!-- Replace icon with SVG -->
                                <svg class="w-[35px] h-[35px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#FFD700" viewBox="0 0 24 24">
                                    <path fill-rule="evenodd" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4Zm0 6h16v6H4v-6Z" clip-rule="evenodd"/>
                                    <path fill-rule="evenodd" d="M5 14a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1Z" clip-rule="evenodd"/>
                                </svg>
                            </div>
                            <h5 class="font-weight-bold">Flexible Payments</h5>
                            <p class="text-muted">Pay with EcoCash, Visa, or MasterCard.</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="icon-box p-3 rounded bg-white shadow-sm">
                            <div class="icon text-primary mb-2">
                                <!-- Replace icon with SVG -->
                                <svg class="w-[35px] h-[35px] text-primary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#2ecc71" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linejoin="round" stroke-width="2.2" d="M4 4h6v6H4V4Zm10 10h6v6h-6v-6Zm0-10h6v6h-6V4Zm-4 10h.01v.01H10V14Zm0 4h.01v.01H10V18Zm-3 2h.01v.01H7V20Zm0-4h.01v.01H7V16Zm-3 2h.01v.01H4V18Zm0-4h.01v.01H4V14Z"/>
                                    <path stroke="currentColor" stroke-linejoin="round" stroke-width="2.2" d="M7 7h.01v.01H7V7Zm10 10h.01v.01H17V17Z"/>
                                </svg>
                            </div>
                            <h5 class="font-weight-bold">Instant Confirmation</h5>
                            <p class="text-muted">Receive your QR code immediately after purchasing.</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="icon-box p-3 rounded bg-white shadow-sm">
                            <div class="icon text-primary mb-2">
                                <!-- Replace icon with SVG -->
                                <svg class="w-[35px] h-[35px] text-primary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#e74c3c" viewBox="0 0 24 24">
                                    <path fill-rule="evenodd" d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" clip-rule="evenodd"/>
                                </svg>
                            </div>
                            <h5 class="font-weight-bold">Safe and Secure</h5>
                            <p class="text-muted">Magetsi ensures your data is always protected.</p>
                        </div>
                    </div>
                </div>

                <!-- Call to Action Button -->
                <div class="d-flex justify-content-center mt-5">
                    <a href="/business/register" class="btn btn-primary btn-lg text-white mb-3">Get Started</a>
                </div>

            </div>
        </section>
        </section></div>


</template>


<style scoped>
.blog-post img {
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}
</style>


<style scoped>
.blog-post img {
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.image-overlay-wrapper {
    position: relative;
}

.card-img-top {
    border-radius: 8px 8px 0 0;
}


.image-container {
    position: relative;
    overflow: hidden;
    border-radius: 8px;

}





.toast-notification {
    position: fixed;
    top: 20px;
    left: 50%;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 9999;

}
.share-option {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333;
    text-decoration: none;
    border-radius: 6px;
    padding: 4px;
    transition: background-color 0.2s ease;
}

.share-option i {
    margin-right: 4px;
    font-size: 18px;
}

.share-option:hover {
    background-color: #f0f0f0;
}

.share-icons {
    display: flex;
    gap: 6px;
    align-items: center;
}


.toast-notification.hide {
    opacity: 0;
    transition: opacity 0.3s ease;
}


</style>
